module.exports = __webpack_public_path__ + "img/portfolio-arrow-right.61d34381.svg";